import React, { FC } from 'react';
import { Box, CustomModalLayout } from '@wix/design-system';
import { ConnectCalendarModalLayoutProps } from '../types';

export const ConnectCalendarModalDesktopLayout: FC<ConnectCalendarModalLayoutProps> = ({
  title,
  subtitle,
  onCloseButtonClick,
  content,
  footnote,
}) => (
  <CustomModalLayout
    showHeaderDivider
    title={title}
    subtitle={subtitle}
    onCloseButtonClick={onCloseButtonClick}
    footnote={footnote}
    content={
      <>
        {content}
        <Box paddingBottom="24px" />
      </>
    }
  />
);
